<template>
  <div class="bg">
    <div class="auth-wrapper auth-v1 px-2">
      <div class="auth-inner py-2">
        <!-- Login v1 -->
        <b-card class="mb-0">
          <!-- <div class="text-center">
            <b-card-title class="mb-1">
              Welcome to LOTTO THE MA5 👋
            </b-card-title>
          </div> -->
          <!-- <div class="text-center mb-1">
            <img
              src="/Infinity_World_21.png"
              alt="logo"
              height="150px"
            >
          </div> -->

          <!-- form -->
          <validation-observer
            v-if="!requires2fa"
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group>
                <label for="username">ชื่อผู้ใช้งาน หรือ เบอร์โทรศัพท์</label>
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] ? 'กรอกชื่อผู้ใช้ให้ถูกต้อง' : '' }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">รหัสผ่าน</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder=""
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0]? 'กรอกรหัสผ่านให้ถูกต้อง' : '' }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  <span class="text-white">จดจำฉันไว้ในระบบ</span>
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                เข้าสู่ระบบ
              </b-button>
            </b-form>
          </validation-observer>

          <div v-else class="auth-login-form">
            <h5 class="text-white mb-1">
              ยืนยันตัวตน (2FA)
            </h5>
            <p class="text-white-50 small mb-2">
              กรอกรหัส 6 หลักจากแอป Authenticator หรือ Recovery Code
            </p>
            <b-form-group>
              <label for="login-otp">รหัสยืนยัน</label>
              <b-form-input
                id="login-otp"
                v-model="otpCode"
                placeholder="123456 หรือ XXXXX-XXXXX"
                autocomplete="one-time-code"
              />
            </b-form-group>
            <b-button
              variant="primary"
              block
              :disabled="!otpCode || loading2fa"
              @click="submit2fa"
            >
              ยืนยัน
            </b-button>
            <b-button
              variant="outline-secondary"
              block
              class="mt-1"
              @click="cancel2fa"
            >
              กลับ
            </b-button>
          </div>

          <!-- <div class="divider my-2">
            <div class="divider-text">
              or
            </div>
          </div> -->
        </b-card>
        <!-- /Login v1 -->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  // BImg,
  // BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCard,
  // BCardTitle,
  BForm,
  BButton,
  VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/auth/jwt/useJwt'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser, clearTwoFaSetupSession, needsAdminTwoFactor, storeTwoFaSetupSession, getTwoFaSetupSession } from '@/auth/utils'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BCard,
    // BImg,
    // BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    // eslint-disable-next-line vue/no-unused-components
    BCardText,
    // BCardTitle,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      requires2fa: false,
      twoFaToken: '',
      accountType: '',
      otpCode: '',
      loading2fa: false,
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      LottoList: [
        { text: 'กรุณาเลือกหวย', value: null, SubList: null },
      ],
      // THG :ผลสลากกินแบ่งรัฐบาล , GSB : ออมสิน, BAAC : ธกส,
      // STH : หุ้นไทย, HN : หวยฮานอย,
      // HNRB : หวยฮานอย แดงดำ, VT : หวยเวียดนาม, ML : หวยมาเลย์ (Magnum4D)
      // LottoSubHead:String,
      // STH = STH1 : หวยหุ้นไทย (เที่ยง), STH2 : หวยหุ้นไทย (บ่าย]), STH3 : หวยหุ้นไทย (เย็น),
      // HN = HNST : หวยฮานอย, HNSP : ฮานอยพิเศษ, HNVIP : ฮานอย วีไอพี Hanoi Vip
      // HNRB = HNR : ฮานอย แดง, HNB : ฮานอย ดำ,
      // VT = VTST : เวียดนาม, VTHCM : โฮจิมินห์ Ho Chi Minh,  VTVIP : เวียดนาม VIP
      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  mounted() {
    getTwoFaSetupSession()

    if (this.$route.query.setup2fa === '1') {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'ต้องเปิด 2FA',
          icon: 'ShieldIcon',
          variant: 'warning',
          text: 'กรุณา login ใหม่เพื่อตั้งค่า 2FA ก่อนใช้งานหลังบ้าน',
        },
      })
    }
  },
  methods: {
    getErrorMessage(error, fallback = 'เกิดข้อผิดพลาด') {
      if (error && error.response && error.response.data && error.response.data.message) {
        return error.response.data.message
      }
      if (error && error.message) {
        return error.message
      }
      return fallback
    },
    completeLogin(userData) {
      if (!userData || !userData.token) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'ERROR',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'Login response invalid',
          },
        })
        return
      }
      clearTwoFaSetupSession()
      useJwt.setToken(userData.token)
      useJwt.setRefreshToken(userData.refreshToken)
      if (needsAdminTwoFactor(userData)) {
        userData.twoFactorEnabled = true
        sessionStorage.setItem('adminTwoFaOk', '1')
      }
      localStorage.setItem('userData', JSON.stringify(userData))
      if (userData.UserToken) {
        localStorage.setItem('UserToken', userData.UserToken)
      }
      this.$ability.update(userData.ability)
      this.$router
        .push(getHomeRouteForLoggedInUser(userData.role, userData.path))
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Welcome to Image Dashboard',
              icon: 'CoffeeIcon',
              variant: 'success',
              text: 'You have successfully logged ',
            },
          })
        })
        .catch(error => {
          if (this.$refs.loginForm) {
            this.$refs.loginForm.setErrors(error.response.data.error)
          }
        })
    },
    cancel2fa() {
      this.requires2fa = false
      this.twoFaToken = ''
      this.accountType = ''
      this.otpCode = ''
    },
    submit2fa() {
      if (!this.otpCode || !this.twoFaToken) return
      this.loading2fa = true
      useJwt
        .login2fa({
          twoFaToken: this.twoFaToken,
          otp: this.otpCode,
          accountType: this.accountType,
        })
        .then(response => {
          this.completeLogin(response.data)
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'ERROR',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: this.getErrorMessage(error, 'รหัสยืนยันตัวตนไม่ถูกต้อง'),
            },
          })
        })
        .finally(() => {
          this.loading2fa = false
        })
    },
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          useJwt
            .login({
              email: this.userEmail,
              password: this.password,
            })
            .then(response => {
              const userData = response.data
              if (userData.requires2fa) {
                clearTwoFaSetupSession()
                this.requires2fa = true
                this.twoFaToken = userData.twoFaToken
                this.accountType = userData.accountType
                this.otpCode = ''
                return
              }
              if (userData.requires2faSetup) {
                storeTwoFaSetupSession(userData.twoFaToken, userData.accountType)
                this.$router.push({ name: 'security-2fa-required' })
                return
              }
              this.completeLogin(userData)
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'เข้าสู่ระบบไม่สำเร็จ',
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: this.getErrorMessage(error, 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง'),
                },
              })
            })
        }
      })
    },
  },
}
</script>

<style scoped>
.bg {
  background: #212534;
}
.card {
    border-radius: 14px !important;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1) !important;
    background-color: rgba(0, 0, 0, 0.774) !important;
  }
  label {
    font-size: 14px;
    font-weight: 500;
    color: #fff;
  }
</style>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
